import StyledReactModal from "./StyledReactModal";

export { ModalFooter } from "./ModalFooter";

export default StyledReactModal;
